import React, { useCallback, useMemo } from 'react';
import { OffersSlice } from '../../../../types';
import { LayoutMode } from '../../types';
import Offer from './offer';
import ProductOfferContainer from '../productOffersContainer';
import { AdsGridContainer } from '../productOffersContainer/container-ads-grid';

type Props = Pick<
  OffersSlice,
  | 'id'
  | 'pageInfo'
  | 'offers'
  | 'productsCount'
  | 'storeCount'
  | 'legalText'
  | 'availableSorts'
  | 'currentSort'
  | 'maxHitsAmount'
>;

const availableSortsTranslations: Record<string, string> = {};

const Offers = ({ offers, ...rest }: Props) => {
  const onLayoutChange = useCallback(() => {}, []);

  const supportedViewModes = useMemo(() => [LayoutMode.GRID], []);
  return (
    <ProductOfferContainer
      {...rest}
      layout={LayoutMode.GRID}
      onLayoutChange={onLayoutChange}
      availableSortsTranslations={availableSortsTranslations}
      supportedViewModes={supportedViewModes}
      displayProductSearch
    >
      <AdsGridContainer>
        {offers.map(offer => (
          <Offer key={offer.id} offer={offer} />
        ))}
      </AdsGridContainer>
    </ProductOfferContainer>
  );
};

export default Offers;
